import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { EmailRequest, ContactUsInfo } from '../../models/contactUs';

//================|| CONTACT US SLICE ||=================//

type ContactUsState = {
    loading: boolean;
    error: ErrorInformation,
    contactUsInfo: ContactUsInfo,
    sendEmailResponseMessage: string
}

const initialState: ContactUsState = {
    loading: true,
    error: null,
    contactUsInfo: null,
    sendEmailResponseMessage: ''
};

export const getContactUsInfo = createAsyncThunk<ContactUsInfo, {}, { rejectValue: ErrorInformation }>(
    "contactus/ContactUsInfo",
    async ({ }, { rejectWithValue }) => {
        try {
            const contactInfoResponse = await axios.get<ContactUsInfo>('/Contact/getContactUsInfo');
            return contactInfoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }

    }
)

export const sendContactUsEmail = createAsyncThunk<number, { emailInfo: EmailRequest }, { rejectValue: ErrorInformation }>(
    "contact/sendContactUsEmail",
    async ({emailInfo}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/Contact/sendContactUsEmail', emailInfo)
            return response.data[0];
           
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }

    }
)

const contactUsSlice = createSlice({
    name: 'contactus',
    initialState,
    reducers: {},
    extraReducers: {
        //get contact us information
        [getContactUsInfo.pending.type]: (state) => {
            state.loading = true;
        },
        [getContactUsInfo.fulfilled.type]: (state, action: PayloadAction<ContactUsInfo | null>) => {
            state.contactUsInfo = action.payload
            state.loading = false;
        },
        [getContactUsInfo.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // send contact us email
        [sendContactUsEmail.pending.type]: (state) => {
            state.loading = true;
        },
        [sendContactUsEmail.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.sendEmailResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [sendContactUsEmail.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
    }
})

export default contactUsSlice